"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const shikumi_map_1 = require("./modules/shikumi-map");
shikumi_map_1.default();
const sweetalert2_1 = require("sweetalert2");
window.addEventListener('load', (_event) => {
    document.querySelectorAll('area.movie').forEach((elem) => {
        const movid = elem.getAttribute('id');
        if (movid) {
            const movfile = movid.replace(/^mov-/, '');
            elem.addEventListener('click', (_event) => {
                const path = `../movie/${movfile}.mp4`;
                const id = `${movid}-media`;
                sweetalert2_1.default.fire({
                    html: `<video src="${path}" autoplay id=${id}></video>`,
                    width: 'auto',
                    willOpen: (popup) => {
                        console.log(popup);
                        const act = popup.querySelector('.swal2-actions');
                        if (act) {
                            act.style.marginTop = '0';
                        }
                        popup.style.paddingBottom = '10px';
                    },
                    didOpen: (_popup) => {
                        const media = document.getElementById(id);
                        if (media) {
                            media.addEventListener('ended', (_event) => {
                                // Swal.close()
                            });
                        }
                    }
                });
            });
        }
    });
});
